//
//
//
//
//
//
//
//
//
//
//

import { isRichtextFilled } from '~/utils/helpers';

export default {
  name: "BaseRichtext",
  props: {
    doc: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isRichtext() {
      return isRichtextFilled(this.doc);
    },
  },
};
